<template>
  <div class="panel granary-right-panel">
    <div class="chart-box">
      <!-- <div ref="chart" class="chart"></div> -->
      <div class="item-top">
        <div class="item-title"><span class="num">37530</span>(个)</div>
        <div>渔业户</div>
      </div>
      <div class="item-center k2">
        <div class="item-title"><span class="num">62</span>(个)</div>
        <div>渔业村</div>
      </div>
      <div class="item-center k3">
        <div class="item-title"><span class="num">192631</span>(人)</div>
        <div>渔业人口</div>
      </div>
      <div class="item-btm k4">
        <div class="item-title"><span class="num">9</span>(个)</div>
        <div>渔业乡</div>
      </div>
      <div class="item-btm k5">
        <div class="item-title"><span class="num">134691</span>(人)</div>
        <div>渔业从业人员</div>
      </div>
      <img class="rk-cent" src="~@/assets/images/granary/yy/人口.png" alt="" />
    </div>
    <!-- <img src="~@/assets/images/granary/yy/echart5.png" alt="" class="echarts-img"> -->
  </div>
</template>

<script>
// import { loadChart } from "./charts/nccyData";
// import { getTop10 } from "@/api/pzsd";
export default {
  data() {
    return {};
  },
  mounted() {
    // this.getData();
  },
  methods: {
    getData() {}
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
.panel
  height 100%
  width 100%
  .chart-box
    width 100%
    height 100%
    position relative
    background url('~images/granary/yy/yyrk-bg.png') no-repeat bottom center
    .item-title
        color #00FFFF
        margin 2px 0
        .num
            font-size 24px
    .rk-cent
        position absolute
        width 111px
        height 80px
        bottom 30px
        left 50%
        transform: translateX(-50%)
    .item-top
        position absolute
        width 84px
        height 98px
        top 5px
        left 50%
        text-align center
        transform translateX(-50%)
        background url('~images/granary/yy/yyrk-b1.png') no-repeat bottom center
    .item-center
        position absolute
        width 84px
        height 102px
        top 30px
        text-align center
        background url('~images/granary/yy/yyrk-b2.png') no-repeat bottom center
    .item-btm
        position absolute
        width 92px
        height 108px
        bottom 40px
        text-align center
        background url('~images/granary/yy/yyrk-b3.png') no-repeat bottom center
    .k2
        left 30%
        transform translateX(-50%)
    .k3
        right 30%
        transform translateX(50%)
    .k4
        left 20px
    .k5
        right 20px
  .echarts-img
    height 240px
    margin 0 auto
    display block
</style>
